import { IntegrationSystem } from "../../types";
import { RapidmailConnectView } from "./ConnectView";
import { RapidmailSettingsView } from "./SettingsView";

export const RapidmailSystem: IntegrationSystem = {
  ConnectView: RapidmailConnectView,
  SettingsView: RapidmailSettingsView
};
